import { pathToRegexp } from "path-to-regexp";

import fetchSeasons from "@/game-fortnite/fetches/seasons.mjs";
import { catchAllRoutes } from "@/routes/constants.mjs";
import type { BaseRoute } from "@/routes/routes.mjs";
import appRouteArticles from "@/util/app-route-articles.mjs";
import lazyFn from "@/util/lazy-fn.mjs";
import pathRegExp from "@/util/path-regexp.mjs";

const fetchProfile = lazyFn(
  () => import("@/game-fortnite/fetches/profile-page.mjs"),
);
const fetchMatch = lazyFn(
  () => import("@/game-fortnite/fetches/match-page.mjs"),
);
const fetchStats = lazyFn(
  () => import("@/game-fortnite/fetches/weapon-statistics.mjs"),
);
const fetchMapData = lazyFn(
  () => import("@/game-fortnite/fetches/fetch-map-data.mjs"),
);

// const fetchLeaderboard = lazyFn(
//   () => import("@/game-fortnite/fetches/leaderboard.mjs"),
// );

const fetchDatabaseData = lazyFn(
  () => import("@/game-fortnite/fetches/database.mjs"),
);

const fetchDatabaseWeaponsData = lazyFn(
  () => import("@/game-fortnite/fetches/database-weapon.mjs"),
);

const fetchShopData = lazyFn(
  () => import("@/game-fortnite/fetches/item-shop.mjs"),
);

const fetchShopOfferData = lazyFn(
  () => import("@/game-fortnite/fetches/item-shop-offer.mjs"),
);

const routes: BaseRoute[] = [
  {
    path: pathRegExp("/fortnite/profile/:profileId{/:tab}?"),
    component: "game-fortnite/Profile.tsx",
    fetchData: fetchProfile,
  },
  {
    path: pathRegExp(
      "/fortnite/match/:profileId/:seasonId/:matchId{/:tab}?{/:tabId}?",
    ),
    component: "game-fortnite/Match.tsx",
    fetchData: fetchMatch,
  },
  {
    path: "/fortnite/stats",
    redirect: "/fortnite/stats/weapons",
  },
  {
    path: pathRegExp("/fortnite/stats/:tab"),
    // component: "game-fortnite/components/ComingSoonStatistics.tsx",
    component: "game-fortnite/Statistics.tsx",
    fetchData: fetchStats,
  },
  {
    path: "/fortnite/leaderboard",
    redirect: "/fortnite/leaderboard/general",
  },
  {
    path: pathRegExp("/fortnite/leaderboard/:tab"),
    component: "game-fortnite/components/ComingSoonLeaderboard.tsx",
    // fetchData: fetchLeaderboard,
  },
  {
    path: "/fortnite/in-game",
    component: "game-fortnite/InGame.tsx",
  },
  {
    path: "/fortnite/database",
    redirect: "/fortnite/database/weapons",
  },
  {
    path: "/fortnite/database/weapons",
    redirect: "/fortnite/database/weapons/active",
  },
  {
    path: "/fortnite/database/weapons/suppressed-submachine-gun",
    redirect: "/fortnite/database/weapons/active",
  },
  {
    path: pathRegExp("/fortnite/database/weapons/:tab"),
    component: "game-fortnite/DatabaseWeapons.tsx",
    fetchData: fetchDatabaseData,
  },
  {
    path: pathRegExp(
      "/fortnite/database/(resources|utilities|consumables|vehicles)",
    ),
    component: "game-fortnite/Database.tsx",
  },
  {
    path: pathRegExp("/fortnite/database/weapon/:id"),
    component: "game-fortnite/DatabaseWeapon.tsx",
    fetchData: fetchDatabaseWeaponsData,
  },
  {
    path: "/fortnite/shop",
    component: "game-fortnite/components/Shop.tsx",
    fetchData: fetchShopData,
  },
  {
    path: pathToRegexp("/fortnite/shop/:offerId"),
    component: "game-fortnite/components/ShopOffer.tsx",
    fetchData: fetchShopOfferData,
  },
  {
    path: "/fortnite/overlays",
    component: "game-fortnite/components/Overlays.tsx",
  },
  {
    path: "/fortnite/map",
    component: "game-fortnite/InteractiveMap.tsx",
    fetchData: fetchMapData,
  },
  {
    path: "/fortnite/custom-maps",
    component: "game-fortnite/ShopMaps.tsx",
  },
  ...appRouteArticles("fortnite"),
];

// The catch-all route should be used for fetching any general static data that is
// related to the routes.
routes.push({
  [catchAllRoutes]: routes,
  fetchData() {
    return fetchSeasons();
  },
});

export default routes;
